import {
  Box,
  Dialog,
  Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { CircleCheck, X } from "lucide-react";
import {
  useEffect, useState
} from "react";

import { useTranslation } from "react-i18next";
import {
  DeleteContentModalBox
} from "./DeleteContentModal.styles";
import { DeleteContentModalProps } from "./DeleteContentModal.types";

import {
  ButtonText,
  Spinner
} from "..";
import { TitleTypography } from "../../components/CreateContentModal/CreateContentModal.styles";
import { POST_TYPE } from "../../consts";
import {
  usePostDeleteQuery
} from "../../queries/community";

export function DeleteContentModal({
  closeDrawer,
  id,
  isModerator,
  onClose,
  open,
  postType,
  selectedFilter,
  selectedTopic,
  ...props
}: DeleteContentModalProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [showSuccess, setShowSuccess]=useState(false);

  const {
    mutate: mutateDeleteTopic,
    isLoading: deleteIsloading,
    isIdle: deleteIsIdle,
    isSuccess: deleteIsSuccess,
    isError: deleteIsError,
    reset:deleteReset
  } = usePostDeleteQuery(
    postType === POST_TYPE.FREE ?
      {
        id:id,
        isModerator:isModerator,
        postType:postType,
        selectedFilter:selectedFilter,
        selectedTopic:selectedTopic
      } : {
        id:id,
        isModerator:isModerator,
        loId:"loId" in props ? props.loId : "",
        postType:postType,
        selectedFilter:selectedFilter ,
        selectedTopic:selectedTopic
      });

  useEffect(() => {
    if(!deleteIsIdle && !deleteIsloading && deleteIsSuccess) {
      setShowSuccess(true);
      deleteReset();
      setTimeout(()=> {
        closeDrawer();
      },1000);
    }
  },[
    closeDrawer,
    deleteIsIdle,
    deleteIsSuccess,
    deleteIsloading,
    deleteReset]);

  return (
    <Dialog
      maxWidth={ false }
      open={ open }
      onClose={ onClose }
      scroll={ "paper" }
      sx={ {
        ".MuiDialog-paper": {
          background: theme.customColors.backgroundCard,
          border: `2px solid ${theme.customColors.border}`,
          borderRadius: "1.125rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          minHeight: "fit-content !important",
          minWidth: "32rem",
          transition: "all 0.2s ease",
          [theme.breakpoints.down("sm")]: {
            minWidth: "calc(100% - 2rem)"
          }
        }
      } }
    >

      <DeleteContentModalBox
        container
        { ...props }
      >
        {
          !deleteIsIdle && deleteIsloading ?
            ( <Spinner/>) :
            !deleteIsIdle && deleteIsError ?
              ( <TitleTypography>{ t("error_occurred") }</TitleTypography>) :
              showSuccess ? (
                <Stack
                  direction={ "column" }
                  alignItems={ "center" }
                  justifyContent={ "center" }
                  gap={ "16px" }
                >
                  <CircleCheck size={ "48px" }/>
                  <TitleTypography
                    tabIndex={ -1 }
                    id="success-title">
                    { t("deleted_post") }
                  </TitleTypography>
                </Stack>
              ) :
                ( <Stack gap={ "24px" } width="100%">
                  <Box
                    sx={ {
                      position: "absolute",
                      right: "1.25rem"
                    } }
                  >
                    <X
                      aria-label={ t("close") }
                      role="button"
                      tabIndex={ 0 }
                      size={ "1.5rem" }
                      cursor="pointer"
                      color={ theme.customColors?.textPrimary }
                      onClick={ closeDrawer }
                      onKeyDown={ (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          closeDrawer();
                        }
                      } }
                    />
                  </Box>
                  <TitleTypography sx={ { textAlign: "center" } }>
                    { t("delete_question") }
                  </TitleTypography>
                  <Stack
                    direction={ "row" }
                    justifyContent={ "center" }
                    gap={ "24px" }>
                    <ButtonText onClick={ () => mutateDeleteTopic() }>
                      { t("yes") }
                    </ButtonText>
                    <ButtonText onClick={ closeDrawer }>
                      { t("no") }
                    </ButtonText>
                  </Stack>
                </Stack>)
        }

      </DeleteContentModalBox>
    </Dialog>
  );

}
